import React from "react";
import * as Icons from "lucide-react";

export function StatCard({ icon, label, value, sub, tone = "default", testId, onClick }) {
  const Icon = icon ? (Icons[icon] || Icons.Circle) : null;
  const tones = {
    default: "text-[#FFB000] bg-[#FFB000]/10",
    green: "text-[#3D8B65] bg-[#3D8B65]/10",
    amber: "text-[#B87F1E] bg-[#D99A32]/12",
    red: "text-[#C95555] bg-[#C95555]/10",
    blue: "text-[#4A78A8] bg-[#4A78A8]/10",
    dark: "text-[#FFC24D] bg-[#0B1729]",
  };
  return (
    <div
      data-testid={testId}
      onClick={onClick}
      className={`amden-card amden-card-hover p-5 ${onClick ? "cursor-pointer" : ""}`}
    >
      <div className="flex items-start justify-between">
        <div>
          <div className="text-xs font-medium uppercase tracking-wide text-[#1E2D44]/50">{label}</div>
          <div className="mt-2 font-display text-2xl font-bold text-[#0B1729]">{value}</div>
          {sub && <div className="mt-1 text-xs text-[#1E2D44]/55">{sub}</div>}
        </div>
        {Icon && (
          <span className={`flex h-10 w-10 items-center justify-center rounded-xl ${tones[tone]}`}>
            <Icon size={18} strokeWidth={2} />
          </span>
        )}
      </div>
    </div>
  );
}
